import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BUILD_TIMESTAMP } from './version';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Log the current build timestamp
console.log(`App initialized with build timestamp: ${BUILD_TIMESTAMP}`);

// Register the service worker with automatic force update
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;
    
    if (waitingServiceWorker) {
      // Skip waiting and force update immediately
      console.log('New version detected! Forcing update...');
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      
      // Give a small delay before reloading to ensure the new service worker is activated
      setTimeout(() => {
        console.log('Reloading page to apply new version...');
        window.location.reload();
      }, 1000);
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
